/**
 * Professional Product Restrictions
 * Prevents non-professional customers from adding professional-only products to cart
 */

class ProfessionalRestrictions {
  constructor() {
    this.init();
  }

  init() {
    // Check if we're on a product page with professional-only products
    if (this.isProfessionalProduct()) {
      this.setupCartProtection();
      this.setupFormInterception();
    }
  }

  isProfessionalProduct() {
    // Check if current product has professional-only tag
    const productTags = document.querySelector('[data-product-tags]');
    if (productTags) {
      const tags = productTags.dataset.productTags.split(',');
      return tags.includes('professional-only');
    }
    return false;
  }

  setupCartProtection() {
    // Intercept cart additions
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (form && form.matches('[data-type="add-to-cart-form"]')) {
        if (!this.isCustomerProfessional()) {
          event.preventDefault();
          this.showProfessionalLoginMessage();
          return false;
        }
      }
    });

    // Intercept AJAX cart additions
    document.addEventListener('cart:item-added', (event) => {
      if (this.isProfessionalProduct() && !this.isCustomerProfessional()) {
        // Remove the item from cart
        this.removeItemFromCart(event.detail.variant_id);
      }
    });
  }

  setupFormInterception() {
    // Intercept form submissions
    const forms = document.querySelectorAll('[data-type="add-to-cart-form"]');
    forms.forEach(form => {
      form.addEventListener('submit', (event) => {
        if (!this.isCustomerProfessional()) {
          event.preventDefault();
          this.showProfessionalLoginMessage();
          return false;
        }
      });
    });
  }

  isCustomerProfessional() {
    // Check if customer has professional tag
    // This would need to be set by the server-side template
    const customerTags = document.querySelector('[data-customer-tags]');
    if (customerTags) {
      const tags = customerTags.dataset.customerTags.split(',');
      return tags.includes('professional');
    }
    return false;
  }

  showProfessionalLoginMessage() {
    // Show message to user
    const message = document.createElement('div');
    message.className = 'professional-login-message alert alert--error';
    message.innerHTML = `
      <div class="flex items-center gap-2">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
        </svg>
        <span>This product is only available to professional customers. <a href="/account/login" class="underline">Login as professional</a> to purchase.</span>
      </div>
    `;

    // Insert message before the form
    const form = document.querySelector('[data-type="add-to-cart-form"]');
    if (form) {
      form.parentNode.insertBefore(message, form);
      
      // Remove message after 5 seconds
      setTimeout(() => {
        if (message.parentNode) {
          message.parentNode.removeChild(message);
        }
      }, 5000);
    }
  }

  async removeItemFromCart(variantId) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 0
        })
      });

      if (response.ok) {
        // Trigger cart update event
        document.dispatchEvent(new CustomEvent('cart:updated'));
        this.showProfessionalLoginMessage();
      }
    } catch (error) {
      console.error('Error removing item from cart:', error);
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProfessionalRestrictions();
});

// Also initialize on page load for dynamic content
window.addEventListener('load', () => {
  new ProfessionalRestrictions();
});
